module.exports = __webpack_public_path__ + "static/img/img_reject@2x.1786686659715.png";